<div class="box">
    <div class="content">
        <!-- <div>
            <div class="HeaderSet">
                <span fxFlex="20">Nature</span>
                <span fxFlex="20">Request No.</span>
                <span fxFlex="20">Equipment</span>
                <span fxFlex="20">Request Date</span>
                <span fxFlex="20">POLs</span>
                <span fxFlex="20">PODs</span>
            </div>
            <div class="rowSet ">
                <ng-container [ngSwitch]="ackService.selectedRequest?.request_type?.dev_name">
                    <span fxFlex="20"
                        *ngSwitchCase="'lease'">{{ackService.selectedRequest?.transaction_type=='use'}}</span>
                    <span fxFlex="20" *ngSwitchCase="'one_way'">{{ackService.selectedRequest?.transaction_type=='use'?
                        'One Way-Use':'One Way-Supply'}}</span>
                    <span fxFlex="20" *ngSwitchCase="'buy_sell'">{{ackService.selectedRequest?.transaction_type=='use'?
                        'Trade-Buy':'Trade-Sell'}}</span>
                </ng-container>
                <span fxFlex="20">{{ackService.selectedRequest?.request_number}}</span>

                <span fxFlex="20" *ngFor="let item of ackService.selectedRequest?.requirement">
                    {{item?.quantity}}*{{item?.container_size_type?.display}} ({{item?.condition?.value}})
                </span>

                <span fxFlex="20"> {{ackService.selectedRequest.request_date == null ? "-" :
                    ackService.selectedRequest?.request_date |
                    date:"dd MMM, yyyy"}}</span>

                <span fxFlex="20" *ngIf="ackService.selectedRequest?.pols.length">
                    {{ackService.selectedRequest?.pols[0].name_display}}
                    <ng-container *ngIf="ackService.selectedRequest?.pols?.length>1">
                        <p [matTooltip]="ackService.selectedRequest?.pols | tooltipList " matTooltipClass="tooltip-list"
                            matTooltipHideDelay="2000">
                            + {{ackService.selectedRequest?.pols?.length - 1}} more
                        </p>
                    </ng-container>
                </span>

                <span fxFlex="20" *ngIf="ackService.selectedRequest?.pods.length">
                    {{ackService.selectedRequest?.pods[0].name_display}}
                    <ng-container *ngIf="ackService.selectedRequest?.pods?.length>1">
                        <p [matTooltip]="ackService.selectedRequest?.pods | tooltipList" matTooltipClass="tooltip-list"
                            matTooltipHideDelay="2000">
                            + {{ackService.selectedRequest?.pods?.length - 1}} more
                        </p>
                    </ng-container>
                </span>
            </div>
        </div> -->
        <div class="header">
            <!-- <span> Share Request</span> -->
            <span>{{changeToStatus}}</span>
            <span class="desc">Select user to Share the request.</span>
        </div>
        <div class="input">
            <div class="field">
                <span>Allocated User* </span>
                <!-- <app-select-field [isEditable]="true" [(ngModel)]="transferObject.allocated_to"
                    [name]="'decline_reason'" [displayField]="'first_name'" [options]="user_List?.results"
                    class="align-items-center" [errors]="errorObj.allocated_to">
                </app-select-field> -->
                <!-- <app-mat-auto-search [isEditable]="true" [displayField]="'first_name'" [name]="'allocated_to'"
                    [(ngModel)]="transferObject.allocated_to"  [options]="user_List?.results"
                    [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem" fxFlex="12em" fxLayout="column"
                    [errors]="errorObj.allocated_to">
                </app-mat-auto-search> -->
                <!-- placeholder="Search by Name or Email"   not needed -->
                <app-mat-auto-search [isEditable]="true" [displayField]="'first_name'" [setSearchValue]="false"
                    [name]="'email'" [(ngModel)]="transferObject.allocated_to" [idField]="null"
                    [errors]="errorObj.allocated_to"
                    [listUrl]="userMaster_url+'user_list/?search=::search::&is_internal=1'"
                    [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem">
                </app-mat-auto-search>
            </div>
            <div class="field">
                <span>Share Reason*</span>
                <app-select-field [isEditable]="true" [(ngModel)]="transferObject.transfer_reason"
                    [name]="'decline_reason'" [displayField]="'name'" [options]="reason_List?.results"
                    class="align-items-center" [errors]="errorObj.transfer_reason">
                </app-select-field>
            </div>
            <div class="field">
                <span>Remark</span>
                <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="transferObject.remarks"
                    [name]="'name'" [errors]="errorObj.remarks">
                </app-text-field>
            </div>
        </div>
        <div class="w-100">
            <mat-checkbox color="primary" [(ngModel)]="transferObject.add_user_to_similar_requests" checked>Share
                this combination of location to assigned user in future also.
            </mat-checkbox>
        </div>
    </div>
    <div class="btnSet">
        <!-- <button mat-raised-button class="Save">Go back</button> -->
        <button mat-raised-button class="Save" (click)="saveRequest()">Share</button>
    </div>
</div>
<div class="bg" [class.set]="true"></div>

<!-- //template for User -->
<ng-template #userItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item.first_name}} {{item.last_name}}
        </span>
        <span class="email">
            {{item.email}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item.first_name}} {{item.last_name}}
</ng-template>